import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { usefulLinkAPI } from '../../api/api';
import './UsefulLinksMenu.css';
import { onayla } from '../../utils/onayla';

const UsefulLinksMenu = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', url: '' });
  const [editingLink, setEditingLink] = useState(null);

  const isAdmin = () => {
    if (!user) return false;
    const role = user.Role ?? user.role ?? '';
    return role === 'Admin';
  };

  useEffect(() => {
    if (isOpen) {
      loadLinks();
    }
  }, [isOpen]);

  const loadLinks = async () => {
    try {
      setLoading(true);
      const data = await usefulLinkAPI.getAll();
      setLinks(data || []);
    } catch (error) {
      console.error('Linkler yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddClick = () => {
    setEditingLink(null);
    setFormData({ name: '', url: '' });
    setShowAddForm(true);
  };

  const handleEditClick = (link) => {
    setEditingLink(link);
    setFormData({
      name: link.name || link.Name || '',
      url: link.url || link.Url || ''
    });
    setShowAddForm(true);
  };

  const handleDeleteClick = async (id) => {
    if (!await onayla('Bu linki silmek istediğinize emin misiniz?')) {
      return;
    }
    try {
      await usefulLinkAPI.delete(id);
      await loadLinks();
      alert('Link başarıyla silindi.');
    } catch (error) {
      console.error('Link silinirken hata:', error);
      alert('Link silinirken hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingLink) {
        await usefulLinkAPI.update(editingLink.id || editingLink.Id, formData);
        alert('Link başarıyla güncellendi.');
      } else {
        await usefulLinkAPI.create(formData);
        alert('Link başarıyla eklendi.');
      }
      setShowAddForm(false);
      setEditingLink(null);
      setFormData({ name: '', url: '' });
      await loadLinks();
    } catch (error) {
      console.error('Link kaydedilirken hata:', error);
      alert('Link kaydedilirken hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleLinkClick = (url) => {
    window.open(url, '_blank');
  };

  if (!isOpen) return null;

  return (
    <>
      {isOpen && <div className="useful-links-overlay" onClick={onClose}></div>}
      <div className={`useful-links-menu ${isOpen ? 'open' : ''}`}>
        <div className="useful-links-header">
          <h3>🔗 FAYDALI LİNKLER</h3>
          <button className="useful-links-close" onClick={onClose}>×</button>
        </div>
        <div className="useful-links-content">
          {loading ? (
            <div className="loading">Yükleniyor...</div>
          ) : links.length === 0 ? (
            <div className="no-links">Henüz link eklenmemiş.</div>
          ) : (
            <div className="links-list">
              {links.map((link) => (
                <div key={link.id || link.Id} className="link-item">
                  <button
                    className="link-button"
                    onClick={() => handleLinkClick(link.url || link.Url)}
                  >
                    {link.name || link.Name}
                  </button>
                  {isAdmin() && (
                    <div className="link-actions">
                      <button
                        className="btn-edit"
                        onClick={() => handleEditClick(link)}
                        title="Düzenle"
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => handleDeleteClick(link.id || link.Id)}
                        title="Sil"
                      >
                        🗑️
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {isAdmin() && (
            <div className="useful-links-footer">
              <button className="btn-add-link" onClick={handleAddClick}>
                + Link Ekle
              </button>
            </div>
          )}
        </div>
      </div>

      {showAddForm && (
        <div className="link-form-overlay" onClick={() => setShowAddForm(false)}>
          <div className="link-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="link-form-header">
              <h3>{editingLink ? 'Link Düzenle' : 'Yeni Link Ekle'}</h3>
              <button className="link-form-close" onClick={() => setShowAddForm(false)}>×</button>
            </div>
            <form onSubmit={handleFormSubmit} className="link-form">
              <div className="form-group">
                <label>Link Adı *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                  required
                  placeholder="Örn: Google"
                />
              </div>
              <div className="form-group">
                <label>URL *</label>
                <input
                  type="url"
                  value={formData.url}
                  onChange={(e) => setFormData(prev => ({ ...prev, url: e.target.value }))}
                  required
                  placeholder="https://www.google.com"
                />
              </div>
              <div className="form-actions">
                <button type="button" onClick={() => setShowAddForm(false)} className="btn-cancel">
                  İptal
                </button>
                <button type="submit" className="btn-submit">
                  {editingLink ? 'Güncelle' : 'Ekle'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UsefulLinksMenu;

